import ApiEndpointConstants from '../constants/api/ApiEndpointConstants';
import api from './FB_EVENT_BASE_API';

export const fetchTranslations = (params) => {
  return api.post(
      `${ApiEndpointConstants.TRANSLATION}`,
      {url: window.location.host}
  );
}